import Card from "../components/Card";
import Image from "../components/Image";
import LottieContainer from "../components/LottieContainer";

function OipUi(parentAnim) {
  return (
    <div className=" w-full h-full flex justify-center items-center translate-z-40 relative">
      <div className="oip-welcome w-full h-full flex justify-center items-center translate-z-40 absolute top-0 left-0">
        <Card
          width="auto"
          height="auto"
          borderRadius="rounded-3xl"
          innerContent={
            <Image
              containerCss={
                "flex justify-center item-center rounded-3xl overflow-hidden"
              }
              src={
                "https://res.cloudinary.com/dl5mqatis/image/upload/v1647780262/passage/passage-showcase/welcome_oip_y241yj.png"
              }
            />
          }
        />
      </div>
      <div className="oip-choices w-full h-full flex justify-center items-center translate-z-40 absolute top-0 left-0">
        <Card
          width="auto"
          height="auto"
          borderRadius="rounded-3xl"
          innerContent={
            <Image
              containerCss={
                "flex justify-center item-center rounded-3xl overflow-hidden"
              }
              src={
                "https://res.cloudinary.com/dl5mqatis/image/upload/v1647780262/passage/passage-showcase/please_select_your_purpose_dzhpqr.png"
              }
            />
          }
        />
      </div>
      <div className="oip-email w-full h-full flex justify-center items-center translate-z-40 absolute top-0 left-0">
        <Card
          width="auto"
          height="auto"
          borderRadius="rounded-3xl"
          innerContent={
            <Image
              containerCss={
                "flex justify-center item-center rounded-3xl overflow-hidden"
              }
              src={
                "https://res.cloudinary.com/dl5mqatis/image/upload/v1647780262/passage/passage-showcase/email_d3hvtx.png"
              }
            />
          }
        />
      </div>
      <div className="oip-pay w-full h-full flex justify-center items-center translate-z-40 absolute top-0 left-0">
        <Card
          width="auto"
          height="auto"
          borderRadius="rounded-3xl"
          innerContent={
            <Image
              containerCss={
                "flex justify-center item-center rounded-3xl overflow-hidden"
              }
              src={
                "https://res.cloudinary.com/dl5mqatis/image/upload/v1647780262/passage/passage-showcase/pricing_lwthit.png"
              }
            />
          }
        />
      </div>
      <div className="oip-workflow w-full h-full flex justify-center items-center translate-z-40 absolute top-0 left-0">
        <Card
          width="auto"
          height="auto"
          borderRadius="rounded-3xl"
          innerContent={<LottieContainer />}
        />
      </div>
    </div>
  );
}

export default OipUi;
